export default __webpack_public_path__ + "static/media/October2018.8861dacc.png";